import styles from './navbar.module.css'
import {useState} from "react";
import logo from "../../../images/Logo.png"
import {Link, NavLink} from "react-router-dom";
import {UserAuth} from "../../../context/AuthContext";

const Navbar = (props) =>
{
	const {user} = UserAuth();
	const [getActive, setActive] = useState(false)
	const toggle = () =>
	{
		setActive(!getActive)
	}
	return (
		<>
			<nav className={styles.navbar}>
				<div className={styles.logo}><Link to="/"><img src={logo} alt=""/></Link></div>
				<ul className={getActive ? styles.active + ' ' + styles.ul: styles.ul}>
					<li><NavLink onClick={toggle} className={({isActive}) => isActive ? styles.actived : ''} to="/">Home</NavLink></li>
					<li><NavLink onClick={toggle} className={({isActive}) => isActive ? styles.actived : ''} to="menu">Menu</NavLink></li>
					<li><NavLink onClick={toggle} className={({isActive}) => isActive ? styles.actived : ''} to="about">About Us</NavLink></li>
					<li><NavLink onClick={toggle} className={({isActive}) => isActive ? styles.actived : ''} to="contact">Contact Us</NavLink></li>
					{user && <li className={styles.contactSm}>Cart</li>}
					<li className={styles.contactSm}> <NavLink to="logIn" onClick={toggle}>{user ? user.email : 'Profile'}</NavLink></li>
				</ul>
				<div className={styles.content}>
					{user && <div className={styles.contactLg}>Ca</div>}
					<div className={styles.contactLg}><NavLink to="logIn" onClick={toggle}>{user ? user.email : 'Pr'}</NavLink></div>
				</div>

				<div onClick={toggle} className={getActive ? styles.close : styles.ham}>
					<div className={styles.top}></div>
					<div className={styles.middle}></div>
					<div className={styles.bottom}></div>
				</div>
			</nav>
		</>
	)
}

export default Navbar;